import styled from 'styled-components';
import { breakpoint, font, overflowLayout } from 'styles/globals';
import { bluePrimaryLink } from 'components/Globals/Base/Link/LinkStyles';
import { getBodyStyle, getColor, Theme } from 'styles/theme';
import { contributors } from 'styles/widgets/contributors';
import { details } from 'styles/widgets/details';
import { primaryButton } from 'components/Globals/Base/Button/buttonStyles';

export const StaticPageWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${contributors}
  ${details}
  
  div {
    a,
    h2,
    h3,
    h4,
    h5,
    p,
    ol,
    ul,
    address,
    table,
    .contributors-widget,
    .wp-block-button,
    details
     {
      @media (${breakpoint.mdMin}) {
        padding-left: calc(50% - 308px);
        padding-right: calc(50% - 308px);
      }
    }

    p {
      ${getBodyStyle('graphikCompact', { default: 'medium' })};
      margin-top: 24px;
      margin-bottom: 18px; // 1em
      padding: 0;
      text-align: left;
    }

    p {
      @media (${breakpoint.mdMin}) {
        padding-left: calc(50% - 308px);
        padding-right: calc(50% - 308px);
      }
      @media (${breakpoint.mdMax}){
        padding-left: 16px;
        padding-right: 16px;
      }
    }

    details > summary {
      position: relative;
      h3 {
        width: calc(100% - 16px);
      }
      &::after {
        position: absolute;
        right: 8px;
      }
    }

    ol, ul {
      @media (${breakpoint.mdMax}){
        padding-left: 24px !important;
      }

      li {
        font-weight: 400;
        font-size: 1.125rem;
      }
    }

    .wp-block-heading {
      margin-top: 24px;
    }

    .wp-block-list {
      padding-bottom: 0;

      li {
        line-height: 150%;

        a {
          word-break: break-word;
          overflow-wrap: break-word;
        }
      }
    }
    .wp-block-button {
      position: relative;
  
      > a::after {
       display: none !important;
      }
  
      a:not(.styled-custom-link) {
        ${primaryButton}
        padding: 16px 32px;
        letter-spacing: unset;
        width: fit-content;
        color: ${getColor('textWhite')}!important;
        text-decoration: none!important;
      }
      @media (${breakpoint.mdMin}) {
        margin-top: 16px;
      }
      @media (${breakpoint.mdMax}) {
        padding-left: 16px;
        margin-bottom: 16px;
      }
    }
  }
`;

export const StaticContainer = styled.div<{ theme: Theme }>`
  @media (${breakpoint.lgMin}) {
    &.well {
      margin-top: 48px;
    }
  }
    
  &.recommends h1 {
    color: ${getColor('textWhite')};;
  }

  h1 {
    background: ${getColor('surfaceBrand')};
    font-family: ${font.graphikCond};
    font-weight: 600;
    letter-spacing: -0.5px;
    text-align: left;
    padding: 48px;
    ${overflowLayout('24px', '0')};
    @media (${breakpoint.mdMin}) {  
      padding-left: calc(50% - 308px + 24px);
      padding-right: calc(50% - 308px + 24px);
    } 
    @media (${breakpoint.lgMin}) {  
      padding-left: calc(50% - 308px + 48px);
      padding-right: calc(50% - 308px + 48px);
      margin-top: 0;
    }
  }

  h2 {
    font-family: ${font.graphikCond};
    font-size: 40px;
    font-weight: 600;
    letter-spacing: 0.25px;
    line-height: 40px;
    margin-top: 33px; // 0.83em (40px / 33px = 0.83em)
    margin-bottom: 33px; // 0.83em (40px / 33px = 0.83em)

    @media (${breakpoint.mdMax}){
        padding-left: 16px;
      }
  }

  h3 {
    font-family: ${font.graphikCond};
    font-size: 34px;
    font-weight: 600;
    letter-spacing: 0.25px;
    line-height: 40px;
    margin: 48px auto 0;

    @media (${breakpoint.mdMax}){
      padding-left: 16px;
    }
  }

  h4 {
    font-family: ${font.graphikCond};
    font-size: 28px;
    font-weight: 600;
    letter-spacing: 0.25px;
    line-height: 28px;
    margin: 48px auto 16px;
    padding: 0;

    @media (${breakpoint.mdMax}){
      padding-left: 16px;
    }
  }

  h5 {
    color: ${getColor('accentSecondary')};
    font-family: ${font.graphikCompact};
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.25px;
    line-height: 16px;
    padding: 0;
    text-align: left;
    margin-top: 26px; // 1.67em
    margin-bottom: 0;

    @media (${breakpoint.mdMax}){
      padding-left: 16px;
    }
  }

  h6 { 
    background: ${getColor('surfaceBrand')};
    font-family: ${font.graphikCond};
    font-size: 45px;
    font-weight: 300;
    line-height: 49.5px;
    text-align: left;
    padding: 0 16px 32px 16px;
    ${overflowLayout('0', '0')};
    @media (${breakpoint.mdMin}) {
      padding-left: calc(50% - 308px + 24px);
      padding-right: calc(50% - 308px + 24px);
    }    
    @media (${breakpoint.lgMin}) {
      padding-left: calc(50% - 308px + 48px);
      padding-right: calc(50% - 308px + 48px);
    }
  }

  ol {
    list-style: revert;
    font-family: ${font.graphikCond};
    font-size: 28px;
    font-weight: 600;
    letter-spacing: 0.25px;
    padding-left: 40px;

    &.ordered-list-format {
      li {
        &::marker {
          font-size: 18px;
          font-weight: 400;
        }
      }
      &.bold {
        li {
          &::marker {
            font-weight: 600;
          }
        }
      }
    }


    @media (${breakpoint.mdMin}) {
      margin: 48px auto 16px;
    }

      h4 {
        font-family: ${font.graphikCond};
        font-size: 28px;
        font-weight: 600;
        letter-spacing: 0.25px;
        line-height: 28px;
        margin: 48px auto 16px;
        padding-bottom: 0;
      }

      li {
        font-family: ${font.graphikCond};
        font-size: 28px;
        font-weight: 600;
        letter-spacing: 0.25px;
        margin-left: 15px;

        p {
          ${getBodyStyle('graphikCompact', { default: 'medium' })};
          margin: auto;
          padding: 0;
          text-align: left;
        }
      }

      ul {
        ${getBodyStyle('graphikCompact', { default: 'default' })};
        font-size: 17px;
        margin: 16px auto auto;
        padding-left: 48px;
        padding-bottom: 16px;
        text-align: left;
        list-style: revert;
    
        li {
          ${getBodyStyle('graphikCompact', { default: 'default' })};
          font-size: 17px;
          margin: 16px auto auto;
          padding: 0;
          text-align: left;
        }
      }
  }

  ul {
    ${getBodyStyle('graphikCompact', { default: 'default' })};
    font-size: 17px;
    margin: 16px auto auto;
    padding-left: 48px;
    padding-bottom: 16px;
    text-align: left;
    list-style: revert;

    li {
      ${getBodyStyle('graphikCond', { default: 'default' })};
      font-size: 17px;
      margin-left: 45px;
      padding-bottom: 15px;
      text-align: left;
      
      @media (${breakpoint.mdMax}) {
        margin-left: 15px;
      }

      a {
        color: ${getColor('textLink')};
    
        &:hover {
          color: ${getColor('textSecondary')};
        }
      }
    }
  }

  a {
    ${bluePrimaryLink}
  }

  address {
    div {
      font-family: ${font.graphikCond};
      font-style: normal;
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 0.53px;
      line-height: 23.8px;
      
      @media (${breakpoint.mdMax}){
        padding-left: 16px;
      }
    }
  }

  #privacy-header {
    border-top: 1px solid ${getColor('borderBlack')};
    padding-top: 16px;
    margin-top: 72px;
  }

  figure.wp-block-table {
    display: block;
    font-family: ${font.graphikCond};
    font-style: normal;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0.53px;
    line-height: 23.8px;

    table {
      display: block;
      border-collapse: collapse;
      border-spacing: 0;
      
      tr {
        display: table-row;
      }

      td {
        padding: 8px;
        border: 1px solid ${getColor('borderTertiary')};
        vertical-align: baseline;
      }
    }

  }
`;
